exports = module.exports = require("../../../../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._31DFWX5_Y_FnuZWaqR0E97 .seP3fv72myHa6cQUeJQIb{min-width:2px;outline-style:solid;outline-width:1px}._31DFWX5_Y_FnuZWaqR0E97 ._1j6flYpLODD-kV6q8ppyVr{outline-style:solid;outline-width:1px}", ""]);
// Exports
exports.locals = {
	"monaco-editor": "_31DFWX5_Y_FnuZWaqR0E97",
	"snippet-placeholder": "seP3fv72myHa6cQUeJQIb",
	"finish-snippet-placeholder": "_1j6flYpLODD-kV6q8ppyVr"
};